import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/GasUnits/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/GasUnits/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/GasUnits/GetById`, payload),
    Add: (payload) => Repository.post(`/api/GasUnits/Add`, payload),
    Edit: (payload) => Repository.post(`/api/GasUnits/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/GasUnits/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/GasUnits/ChangeStatus`, payload),
}